
import React, { useState, useEffect } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import {
  Elements,
  PaymentElement,
  useStripe,
  useElements,
} from '@stripe/react-stripe-js';
import { createPaymentIntent } from '../utils/OpenCampground_Database_Calls';

// const stripePromise = loadStripe("pk_test_51PlFw2JAOXmiy96cqhvlr9GnFv8tjrxcqLg9V5fCKaQ2m2NlHXUvLGak81VA3pF20dLL4sdonfRVmbtPZB5ijglN003dYkpg8T");
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUB_KEY);

function CheckoutForm({ billingDetails, onPaymentSuccess, onPaymentFail }) {
  const stripe = useStripe();
  const elements = useElements();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return;

    const { error, paymentIntent } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        payment_method_data: {
          billing_details: billingDetails,
        },
      },
      redirect: "if_required",
    });

    if (error) {
      onPaymentFail(error.message);
    } else {
        await onPaymentSuccess(paymentIntent);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement />
      <button type="submit" style={{ marginTop: '20px', background:'#2dcd7a', borderRadius:'25px', color:'white', width:'20%', height:'40px',border:'none', cursor:'pointer', marginBottom:'20px'}}>
        Pay
      </button>
    </form>
  );
}

function StripePayment({ amount, billingDetails, connectedAccountId, onPaymentSuccess, onPaymentFail }) {
  const [clientSecret, setClientSecret] = useState('');

  useEffect(() => {
    const fetchClientSecret = async () => {
      if (!amount || amount <= 0) return;

      const paymentAmount = Math.round(amount * 100); // convert to cents
      const res = await createPaymentIntent(paymentAmount, connectedAccountId);
      setClientSecret(res.clientSecret);
    };

    fetchClientSecret();
  }, [amount, connectedAccountId]);

  const options = {
    clientSecret,
    appearance: {
      theme: 'flat',
      variables: {
        colorPrimaryText: '#262626',
      },
      layout: {
        type: 'accordion',
      },
    },
    wallets: {
      applePay: 'never',
      googlePay: 'never',
      link: false,
    },
    stripeAccount: connectedAccountId,
  };

  if (!clientSecret) return null;

  return (
    <Elements stripe={stripePromise} options={options}>
      <CheckoutForm billingDetails={billingDetails} onPaymentSuccess={onPaymentSuccess} onPaymentFail={onPaymentFail}/>
    </Elements>
  );
}

export default StripePayment;
